/**
 * The splash loader plays on the first page view of a browser session only.
 *
 * Kept out of the 'use client' loader module on purpose: the root layout (a server
 * component) inlines LOADER_SEEN_SCRIPT, and a constant exported from a client
 * module would reach the server as a client reference instead of a string.
 */

/** sessionStorage key the loader sets once it has played. */
export const LOADER_SEEN_KEY = 'bb_loader_seen';

/** Class on <html> for a repeat page view; globals.css hides the overlay with it. */
export const LOADER_SEEN_CLASS = 'bb-loader-seen';

/**
 * Runs in <head> before the body is parsed, so on a repeat page view the overlay is
 * hidden before first paint and never flashes. Storage can throw (blocked cookies,
 * some private modes): the loader then simply plays again.
 */
export const LOADER_SEEN_SCRIPT = `try{if(sessionStorage.getItem('${LOADER_SEEN_KEY}'))document.documentElement.classList.add('${LOADER_SEEN_CLASS}')}catch(e){}`;
